module.exports = __webpack_public_path__ + "static/media/reglages.eff4c640.png";